import React, {useContext, useEffect, useState} from 'react';
import {AgentContext} from "../context/agent-context.jsx";
import {FaExternalLinkAlt} from "react-icons/fa";
import projectUtils from "../../../../../utils/project-utils.js";
import userService from "../../../../../services/web/user-service.js";
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";

const errorsInfo = [
    {
        error: "cannot.inactivate.user.with.authorized.apps",
        label: "Agente possui dispositivos autorizados",
        link: "user-agents/form/:id?tab=devices"
    },
    {
        error: "cannot.inactivate.user.with.material.caution",
        label: "Agente possui materiais em cautela",
        link: "materials/movements"
    },
    {
        error: "cannot.inactivate.user.in.active.garrison",
        label: "Agente faz parte de uma guarnição ativa",
        link: "despacho/garrison/form/:id"
    },
    {
        error: "cannot.inactivate.user.leader.of.active.garrison",
        label: "Agente é responsável por uma guarnição ativa",
        link: "despacho/garrison"
    }
]

const BASENAME = import.meta.env.BASE_URL;

const UserInactivate = ({open, setOpen, save}) => {
    const {id, user, setUser, setIsLoading} = useContext(AgentContext)
    const [errors, setErrors] = useState(null)
    const [readyToInactivate, setReadyToInactivate] = useState(false)
    const [observation, setObservation] = useState("")

    useEffect(() => {
        if (open) checkInactivate();
    }, [open]);

    useEffect(() => {
        if (readyToInactivate) save();
    }, [readyToInactivate]);

    const checkInactivate = () => {
        setIsLoading(true);

        userService.userInactivate(id)
            .then(({data}) => {
                setErrors(data)
            })
            .catch(error => {
                console.error(error);
                let message = 'Não foi possível prosseguir.';
                projectUtils.swalErrorMessage('', message, 'Ok');
                setOpen(false)
            })
            .finally(() => setIsLoading(false));
    }

    const inactivate = () => {
        setUser(prev => ({...prev,
            user: {
                ...user.user,
                status: false,
                observation: user.user.observation ? user.user.observation +"\n"+ observation : observation
            }
        }));
        setObservation("")
        setReadyToInactivate(true);
        setOpen(false)
    }

    return (
        <>
            <Modal isCloseClick={false} open={open} setOpen={() => setOpen(false)} centered className={"w-4/12"}
                   title={errors !== null && errors.length === 0 ? "Inativação de agente" : "Pendências para agente" }>
                <Modal.Body className={"p-2"}>
                    <ul className="list-group list-group-light">
                        {
                            errors &&
                            errors.map((e, index) => {
                                const errorFind = errorsInfo.find(ef => ef.error === e.error)

                                let link = errorFind?.link;
                                if (e?.additionalData) {
                                    link = link?.replace(":id", e.additionalData);
                                } else {
                                    link = link?.replace(":id", id);
                                }

                                return (
                                    <li key={index}
                                        onClick={() => window.open(`${BASENAME}${link}`, "_blank")}
                                        className="list-group-item flex content-between items-center gap-2">
                                        <p className={"text-[15px]"}>{errorFind?.label}</p>
                                        <span className="badge"><FaExternalLinkAlt color={"#063A6C"}/></span>
                                    </li>
                                )
                            })
                        }
                    </ul>

                    {
                        (errors !== null && errors.length === 0) &&
                        <div className="row">
                            <div className="col-12">
                                <InputTextarea style={{height: '100px'}} label="Observações" value={observation}
                                             onChange={({target: {value}}) => setObservation(value)}
                                />
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer className={"p-2"}>
                    <div className="w-full flex justify-end m-0">
                        {
                            (errors !== null && errors.length === 0) &&
                            <Button target="danger" onClick={inactivate}>Inativar</Button>
                        }

                        {
                            (errors !== null && errors.length > 0) &&
                            <Button target="primary" onClick={checkInactivate}>Verificar novamente</Button>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default UserInactivate;